<template>
  <form
    id="login-form"
    name="login-form"
    @submit.prevent="onFormSubmit"
  >
    <div
      class="fields"
      :class="{'fields--vertical': showFieldVertical}"
    >
      <tg-form-input-text
        v-model="username"
        class="field"
        type="email"
        name="username"
        :label="$t('general.email')|capitalize"
        :required="true"
        :validation="$v.username"
      />
      <tg-form-input-text
        v-model="password"
        class="field"
        name="password"
        type="password"
        :label="$t('general.password')|capitalize"
        :required="true"
        :validation="$v.password"
      />
    </div>
    <tg-button-group>
      <tg-button @click.prevent="onFormSubmit">
        {{ $t('general.login') | capitalize }}
      </tg-button>
      <tg-button
        variant="text"
        @click.prevent="$emit('go-to-forgot-password')"
      >
        {{ $t('text.account.forgot_your_password') | capitalize }}?
      </tg-button>
    </tg-button-group>
  </form>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';

import TgButton from '../buttons/TgButton';
import TgButtonGroup from '../buttons/TgButtonGroup';
import TgFormInputText from './fields/TgFormInputText';
import { nativeFormSubmit } from '~/utils/native-form-post';
import { SET_USERNAME } from '~/store/account/credentials';

export default {
  name: 'TgLoginForm',

  components: {
    TgButtonGroup,
    TgButton,
    TgFormInputText,
  },

  props: {
    url: {
      type: String,
      required: false,
      default: null,
    },
    csrfToken: {
      type: String,
      required: false,
      default: null,
    },
    targetPath: {
      type: String,
      required: false,
      default: null,
    },
    showFieldVertical: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      password: null,
    };
  },

  computed: {
    username: {
      set (username) {
        this.$store.commit(
          `account/credentials/${SET_USERNAME}`,
          username.toLowerCase(),
        );
      },
      get () {
        return this.$store.state.account.credentials.username;
      },
    },
  },

  created () {
    this.getUserNameFromURLSearchParams();
  },

  methods: {
    onFormSubmit () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        if (this.url) {
          nativeFormSubmit(this.url, {
            _csrf_token: this.csrfToken,
            _target_path: this.targetPath,
            _username: this.username,
            _password: this.password,
          });
        }
      }
    },

    getUserNameFromURLSearchParams () {
      if (process.client) {
        const urlParams = new URLSearchParams(window.location.search);
        const username = urlParams.get('username');
        if (username) {
          this.username = username;
          this.$nextTick(() => {
            document.forms['login-form'].elements.password.focus();
          });
        }
      }
    },
  },

  validations: {
    username: {
      required,
      email,
    },
    password: {
      required,
    },
  },
};
</script>

<style scoped>
.fields {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.fields .field {
  margin-bottom: 1rem;
}

@media all and (min-width: 992px) {
  .fields:not(.fields--vertical) {
    flex-direction: row;
    justify-content: space-between;
  }

  .fields:not(.fields--vertical) .field {
    width: calc(50% - .5rem);
  }
}
</style>
